import { getCurrentApiHost, API_NAMESPACE, API_VERSION, NITRO_OAUTH_HOST } from 'config/environment';
const oauthState = {};
const generateRandomString = (length)=>{
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    const randomValues = new Uint8Array(length);
    crypto.getRandomValues(randomValues);
    return Array.from(randomValues, (byte)=>characters.charAt(byte % charactersLength)).join('');
};
function base64UrlEncode(buffer) {
    const arr = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    return btoa(String.fromCharCode(...arr)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function sha256Digest(input) {
    const encoder = new TextEncoder();
    const _data = encoder.encode(input);
    return crypto.subtle.digest('SHA-256', _data);
}
export const redirectToOAuth = async (clientId)=>{
    try {
        const codeVerifier = generateRandomString(43);
        const codeChallenge = base64UrlEncode(await sha256Digest(codeVerifier));
        const randomString = generateRandomString(32);
        const state = base64UrlEncode(new TextEncoder().encode(randomString));
        oauthState.code_verifier = codeVerifier;
        oauthState.state = state;
        oauthState.code_challenge = codeChallenge;
        // Mirror to localStorage too: some browsers (Safari ITP, enterprise policy, incognito) clear
        // sessionStorage during the cross-origin auth redirect, which would lose the PKCE verifier.
        sessionStorage.setItem('codeVerifier', codeVerifier);
        try {
            localStorage.setItem('codeVerifier', codeVerifier);
        } catch (unused) {
        // localStorage may be blocked (private mode / enterprise policy / quota). sessionStorage
        // still holds the verifier for the normal path — don't let this best-effort mirror throw
        // into the outer catch and abort the OAuth redirect to /login.
        }
        const currentHost = window.location.host;
        const currentScheme = window.location.protocol.replace(':', '');
        if (!clientId) {
            return;
        }
        const parameters = new URLSearchParams({
            clientId,
            state,
            codeChallenge,
            codeChallengeMethod: 'S256',
            redirectUri: `${currentScheme}://${currentHost}/implicit/callback`
        });
        const redirectUrl = `${NITRO_OAUTH_HOST}/${clientId}/login?${parameters.toString()}`;
        window.location.href = redirectUrl;
    } catch (unused) {
        window.location.href = '/login';
    }
};
export const exchangeCodeWithId = async (code, redirectUri, codeVerifier, clientId)=>{
    const response = await fetch(`${NITRO_OAUTH_HOST}/${API_NAMESPACE}/${API_VERSION}/token`, {
        method: 'POST',
        headers: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            code,
            redirectUri,
            codeVerifier,
            clientId
        })
    });
    if (!response.ok) {
        throw new Error(`Token exchange failed: ${response.status} ${response.statusText}`);
    }
    return response.json();
};
export const authenticateWithId = async (accessToken)=>{
    const response = await fetch(`${getCurrentApiHost()}/${API_NAMESPACE}/${API_VERSION}/authentication/token?token=${accessToken}`, {
        method: 'POST',
        headers: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Authentication failed: ${response.status} ${response.statusText}`);
    }
};
